import { AssetIcon } from '@/shared/ui/Asset'
import { cn } from '@lair-finance/util'

export function ToggleButton({ className, active, onClick }: { className?: string; active?: boolean; onClick?: () => void }) {
  return (
    <div className={cn('inline-flex-center size-[32px] sm:size-[48px] bg-greyscale-700 rounded-[8px]', className)} onClick={onClick}>
      <AssetIcon filename={active ? 'menu-close.png' : 'hamburger.png'} size={24} />
    </div>
  )
}
